<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/34ycnE/tc-custom/9781610580540.jpg?1725288162605" alt="This image is the cover for the book 300 15-Minute Low-Carb Recipes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">300 15-Minute Low-Carb Recipes
      </h1>
      <p class="bookDescription body article font2">
        <b>Simple, super-speedy dinners, desserts, snacks, sides, and more from the million-selling low-carb guru!</b><br/><br/>Eat well, stay fit, and maintain your low-carb diet with these 300 delicious and easy recipes that can be made in fifteen minutes or less from start to finish. Fast cooking methods will lead you to a fabulous finished product every time! Create delicious, nutritious, filling meals and treats like:<br/><br/>Rosemary-ginger ribs with apricot glaze—Cranberry burgers—Chipotle-bacon breakfast burrito—Chicken chili verde—Beef and bacon “rice” with pine nuts—Thai-style crab salad in avocados—Aladdin salad—Basil-lime shrimp—Salmon in ginger cream—Strawberry ice cream—Mexican chocolate smoothie—and many, many more
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dana Carpender
      </h2>
      
      <p class="authorDescription body article">Dana Carpender (Bloomington, Indiana) is a pioneer of the low-carb movement and best-selling author of over 14 cookbooks, including The New 500 Low-Carb Recipes,1001 Low-Carb Recipes, 500 Paleo Recipes, 15-Minute Low-Carb Recipes, The Low-Carb Diabetes Solution Cookbook, 200 Low-Carb, High-Fat Recipes, The Low-Carb Diabetes Solution, The Insulin Resistance Solution, 500 Ketogenic Recipes, and many more. To date, her books have sold over a million copies worldwide. She writes about low-carb cooking and nutrition on her Facebook page, Dana Carpender's Hold the Toast Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fair Winds Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07fa0782